;(function(w){
	function Formulario(landing_id, landing_url, data, landing_usa, institute_type){ //landing_usa opcional
	var self = this;
	this.main = document.getElementById('formulario');
	
	landing_usa = landing_usa || false;
	var enviar_btn = document.getElementById('formulario_enviar_btn');

	var msg = document.getElementById('formulario_msg');
		
	var enviando = false;

	var warningTelefono = false;
	
	var inputs;

	var actualPage=0;

	var check_recibe_info = null;//Solo se usa si es obligatorio
	grecaptcha.render(document.getElementById('recaptcha'),{
	  'sitekey': RECAPTCHA_SITE_KEY,
	  'size': 'invisible',
	  'badge' : 'bottomright',
	  'callback' : onRecaptcha
	});

	if(formConfigValido()){
		init();
		$(enviar_btn).bind('click', onClickEnviarBtn);

		if($('#formulario .button_next').length>0){
			showPage(actualPage);
			$('#formulario .button_next').bind('click', onClickEnviarBtn);
		}
	}

	this.setPrograma = function(id){
		if(inputs['programa_id'] !== undefined && inputs['recinto_id'] === undefined){
			var programa = data.programas.filter(function(a){return a.id == id})[0];
			
			if(inputs['escuela_id'] !== undefined){
				if(programa != undefined){
					inputs['escuela_id'].seleccionar(programa[0].escuela_id);		
					onChangeEscuela();
				}
			}
			
			if(landing_usa){
				if(programa != undefined){
					if(programa.grupo_id != 0){
						if(inputs['programa_id'].seleccionarByOptionQuery('[data-grupo_id="'+programa.grupo_id+'"][data-tipo="'+programa.tipo+'"]')){
							
							onChangePrograma();

							inputs['track_id'].seleccionar(id);
						}
					}else{
						if(inputs['track_id'] !== undefined){
							inputs['track_id'].clean();
							inputs['track_id'].hide();
						}

						inputs['programa_id'].seleccionar(id);
					}
				}
			}else{
				inputs['programa_id'].seleccionar(id);
			}
		}
	}

	this.setRecinto = function(id){
		if(inputs['recinto_id'] !== undefined){
			inputs['recinto_id'].seleccionar(id);
			onChangeRecinto();
		}
	}

	this.highlight = function(campo){
		if(inputs[campo] !== undefined){
			inputs[campo].highlight();
		}
	}

	function init(){
		inputs = {};
		for(var i=0; i < data.campos.length; i++){
			switch(data.campos[i]){
				case 'nombre':
				case 'apellido':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].setMaxLength(100);
					break;
				case 'tutor_nombre':
				case 'tutor_apellido':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(false);
					inputs[data.campos[i]].setMaxLength(100);
					break;
				case 'email':inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].setEmail();
					inputs[data.campos[i]].setMaxLength(255);
					break;
				case 'tutor_email':inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].setEmail();
					inputs[data.campos[i]].esRequerido(false);
					inputs[data.campos[i]].setMaxLength(255);
					break;			
				case 'telefono':inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					if (data.pais === false || data.pais.nregexp === ''){
						inputs[data.campos[i]].setTelefono();
						inputs[data.campos[i]].setMaxLength(20);
						inputs['telefono'].removeClass('con-prefijo');
						$('#prefijo').hide();
					} else {
						inputs[data.campos[i]].setMaxLengthForExpr(data.pais.nregexp);
						inputs[data.campos[i]].setPais(data.pais);
						inputs['telefono'].addClass('con-prefijo');
						$('#prefijo').show();
					}
				break;
				case 'tutor_telefono':inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					if (data.pais === false || data.pais.nregexp === ''){
						inputs[data.campos[i]].esRequerido(false);
						inputs[data.campos[i]].setTelefono();
						inputs[data.campos[i]].setMaxLength(20);
						inputs['tutor_telefono'].removeClass('con-prefijo');
						$(inputs['tutor_telefono'].getInput()).next().hide();
					} else {
						inputs[data.campos[i]].setMaxLengthForExpr(data.pais.nregexp);
						inputs[data.campos[i]].setPais(data.pais);
						inputs['tutor_telefono'].addClass('con-prefijo');
						$(inputs['tutor_telefono'].getInput()).next().show();
					}
				break;

				case 'telefono_trabajo':inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					if (data.pais === false || data.pais.nregexp === ''){
						inputs[data.campos[i]].setTelefono();
						inputs[data.campos[i]].setMaxLength(20);
						inputs['telefono_trabajo'].removeClass('con-prefijo');
						$('#prefijo').hide();
					} else {
						inputs[data.campos[i]].setMaxLengthForExpr(data.pais.nregexp);
						inputs[data.campos[i]].setPais(data.pais);
						inputs['telefono_trabajo'].addClass('con-prefijo');
						$('#prefijo').show();
					}
				break;

				case 'country':
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);
					
					$(select).bind('change', function (){
						var selected_option = parseInt($(this).attr('selected_option'));
						var val = parseInt(this.value);

						if(val === 0 || val === selected_option){
							return false;
						}
						$(this).attr('selected_option', val);
						data.pais = {
							nombre: $(this).find(":selected").text(),
							codigo: $(this).find(":selected").val(),
							prefijo: $(this).find(":selected").attr('prefijo'),
							nregexp: $(this).find(":selected").attr('nregexp'),
							latam: $(this).find(":selected").attr('latam')
						};

						if(inputs['pueblos_paises'] !== undefined){
							var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
							if(inputs['pueblos_paises'].getAttr('country_selected') !== country_selected){
								inputs['pueblos_paises'].autocompleteReset();
								inputs['pueblos_paises'].showByQuery('[country_code]');
								inputs['pueblos_paises'].hideByQuery('[country_code!="' + country_selected + '"]');
								inputs['pueblos_paises'].setAttr('country_selected', country_selected);
							}
						}

						if(inputs['pueblo_codigo_postal'] !== undefined){
							var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
							if(inputs['pueblo_codigo_postal'].getAttr('country_selected') !== country_selected){
								inputs['pueblo_codigo_postal'].autocompleteReset();
								inputs['pueblo_codigo_postal'].showByQuery('[country_code]');
								inputs['pueblo_codigo_postal'].hideByQuery('[country_code!="' + country_selected + '"]');
								inputs['pueblo_codigo_postal'].setAttr('country_selected', country_selected);
							}
						}
						
						var recintos_por_pais = Array();
						if(inputs['recinto_id'] !== undefined){
							inputs['recinto_id'].clean();
							recinto_total = 0;

							recintos_por_pais = data.recintos.filter(function(a){return a.latam===data.pais.latam});
							var recintos_options = recintos_por_pais.map(function(a){
								return {
									valor:a.id, 
									nombre: data.pais.latam && parseInt(data.pais.latam) === 1 
										? a.nombre_latam 
										: a.nombre,
									selected:false
								}
							})
							inputs['recinto_id'].set(recintos_options);
							if (recintos_options.length === 1){
								inputs['recinto_id'].seleccionar(recintos_options[0].valor);
								$(inputs['recinto_id'].getSelect()).attr('selected_option', recintos_options[0].valor);
							}
						}
						if(inputs['escuela_id'] !== undefined){
							onChangeRecinto();
						}
						if(inputs['programa_id'] !== undefined){
							//onChangeRecinto();
							var	programas = data.programas.filter(function(programa){ 
								return (recintos_por_pais.filter(function (recinto){
									return recinto.programas.indexOf(programa.id) != -1
								})).length > 0;
							}); 
							var programas_options = programas.map(function(a){ return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};});
							inputs['programa_id'].set(programas_options);
							if (programas_options.length === 1){
								inputs['programa_id'].seleccionar(programas_options[0].valor);
								$(inputs['programa_id'].getSelect()).attr('selected_option', programas_options[0].valor);
							}
						}
						$('#prefijo').text(data.pais.prefijo);
						if(data.pais.nregexp === '' || data.pais.nregexp === undefined){
							inputs['telefono'].setTelefono();
							inputs['telefono'].setMaxLength(20);
							inputs['telefono'].removeClass('con-prefijo');
							$('#prefijo').hide();
						} else {
							inputs['telefono'].setMaxLengthForExpr(data.pais.nregexp);
							inputs['telefono'].setPais(data.pais);
							inputs['telefono'].addClass('con-prefijo');
							$('#prefijo').show();
						}
					});
				break;
				case 'pueblos_paises': 
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
					inputs[data.campos[i]] = new FormularioSelect(select);
					inputs[data.campos[i]].setAttr('country_selected', country_selected);
					inputs[data.campos[i]].autocomplete({
						placeholder:'Pueblo'
					});
					$(select).bind('change', function (){
						var pueblo_values = inputs['pueblos_paises'].getValor();
						var selected_option = $(this).attr('selected_option');
						if (selected_option === pueblo_values){
							return;
						}
						if(inputs['pueblo_codigo_postal'] !== undefined){
							if (pueblo_values == 0){
								var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
								inputs['pueblo_codigo_postal'].autocompleteReset();
								inputs['pueblo_codigo_postal'].showByQuery('[country_code]');
								inputs['pueblo_codigo_postal'].hideByQuery('[country_code!="' + country_selected + '"]');
							} else {
								inputs['pueblo_codigo_postal'].autocompleteReset();
								inputs['pueblo_codigo_postal'].hideByQuery('[country_code]');
								zip_codes = pueblo_values.split(',');
								if (zip_codes.length > 1){
									zip_codes.forEach(function(val){
										inputs['pueblo_codigo_postal'].showByQuery('[value="' + val + '"]');
									});
								} else {
									inputs['pueblo_codigo_postal'].seleccionar(pueblo_values);
									inputs['pueblo_codigo_postal'].setAttr('selected_option', pueblo_values);
								}
							}
						}
						$(this).attr('selected_option', pueblo_values);
					});
				break;
				case 'pueblo_codigo_postal': 
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
					inputs[data.campos[i]] = new FormularioSelect(select);
					inputs[data.campos[i]].setAttr('country_selected', country_selected);
					inputs[data.campos[i]].autocomplete({
						placeholder:'Código Postal'
					});
					$(select).bind('change', function (){
						var val = this.value;
						var selected_option = $(this).attr('selected_option');
						var country_selected = data.pais && data.pais.codigo ? data.pais.codigo : '';
						if(selected_option !== val){
							if(inputs['pueblos_paises'] !== undefined){
								inputs['pueblos_paises'].autocompleteReset();
								inputs['pueblos_paises'].showByQuery('[country_code]');
								inputs['pueblos_paises'].hideByQuery('[country_code!="' + country_selected + '"]');
								inputs['pueblos_paises'].seleccionar(val);					
							}
						}
						$(this).attr('selected_option', val);
					});
				break;
				case 'pueblo_codigo_postal_text':
					inputs["pueblo_codigo_postal"] = new FormularioInput($(self.main).find('input[name="pueblo_codigo_postal_text"]')[0]);
					inputs["pueblo_codigo_postal"].setMaxLength(5);
					inputs["pueblo_codigo_postal"].setNumerico();
					inputs["pueblo_codigo_postal"].setName("pueblo_codigo_postal");
					break;
				case 'state':
				case 'previous_education':
				case 'idioma':
				case 'programa_id': 
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);
					$(select).bind('onChangePrograma', onChangePrograma);
					$(select).bind('change', function(e){
						var selected_option = parseInt($(this).attr('selected_option'));
						var val = parseInt(this.value);
						if(val !== 0 && val !== selected_option){
							$(this).trigger('onChangePrograma');
							$(this).attr('selected_option', val);
						}								
					});
					break;
				case 'ofrecimiento': 
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);					   
					$(select).bind('onChangeOfrecimiento', onChangeOfrecimiento);
					$(select).bind('change', function(e){
						var selected_option = parseInt($(this).attr('selected_option'));
						var val = parseInt(this.value);
						if(val !== 0 && val !== selected_option){
							$(this).trigger('onChangeOfrecimiento');
							$(this).attr('selected_option', val);
						}
					});
					break;
				case 'recinto_id': 
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);						   
					$(select).bind('onChangeRecinto', onChangeRecinto);
					$(select).bind('change', function(e){
						var selected_option = parseInt($(this).attr('selected_option'));
						var val = parseInt(this.value);
						if(val !== 0 && val !== selected_option){
							$(this).trigger('onChangeRecinto');
							$(this).attr('selected_option', val);
						}
					});
					break;
				case 'escuela_id':	
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);						   
					$(select).bind('onChangeEscuela', onChangeEscuela);
					$(select).bind('change', function (){
						var selected_option = parseInt($(this).attr('selected_option'));
						var val = parseInt(this.value);
						if(val !== 0 && val !== selected_option){
							$(this).trigger('onChangeEscuela');
							$(this).attr('selected_option', val);
						}
					});	
					break;
				case 'area_de_estudio':	
					var select = $(self.main).find('select[name="'+data.campos[i]+'"]')[0];
					inputs[data.campos[i]] = new FormularioSelect(select);
					break;
				//case 'recibe_info_obligatorio': 
				//	check_recibe_info = $(self.main).find('input[name="recibe_info"]')[0];
				//	var recibe_info_modal = $('.recibe_info_modal')[0];
				//	$(recibe_info_modal).find('.modal-close').bind('click', function(){
				//		$(recibe_info_modal).removeClass('active');
				//	})
				//	$('.check_info_btn').bind('click', function(){
				//		$(recibe_info_modal).addClass('active');
				//	})
				//	break;
				
				//case 'recibe_info_obligatorio': 
				//	check_recibe_info = $(self.main).find('input[name="recibe_info"]')[0];
				//	var recibe_info_bottom = $('.recibe_info_bottom')[0];
				//	$(recibe_info_bottom).hide();
				//	$('.check_info_btn').bind('click', function(evt){
				//		evt.preventDefault();
				//		$(recibe_info_bottom).show();
				//	})
				//	break;
				
				case 'recibe_info_obligatorio': 
					check_recibe_info = $(self.main).find('input[name="recibe_info"]')[0];
					break;
				case 'birthdate':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(true);
					inputs[data.campos[i]].setFecha();
					break;
				case 'codigo_npi':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(true);
					inputs[data.campos[i]].setNPI();
					break;
				case 'participante_activo_mmm':
				case 'participante_mmm':
				case 'nombre_proveedor_mmm':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(true);

					break;
				case 'licencia_enfermeria':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(true);

					$(self.main).find('input[name="'+data.campos[i]+'"]').bind('change', function (){
						if(inputs['escuela_id'] !== undefined){
							onChangeEscuela();
						}
						if(inputs['recinto_id'] !== undefined){
							onChangeRecinto();
						}

						if(inputs['escuela_id'] == undefined && inputs['recinto_id'] == undefined){
							var  le_value=inputs['licencia_enfermeria'].getValor()==1?'1':'0';
							inputs['programa_id'].clean();
							var programas = data.programas.filter(function(a){return a.licencia_rn==le_value});
							var programas_options = programas.map(function(a){ 
								return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};
							});
				
							inputs['programa_id'].set(programas_options);
							//setEscuelasLicenciaRN();
						}

						var dom_text=$(this).closest('.label-check').find('.label-text');
						if(dom_text.length==0){
							var msg_text='';
							if(landing_idioma=='en'){
								msg_text='The Associate Degree in Nursing requires travel to Puerto Rico.';
							}else{
								msg_text='El Grado Asociado en Enfermería requiere viajar a Puerto Rico.';
							}
							$(this).closest('.label-check').append('<div class="label-text" style="padding-top: 6px;line-height: 1.3;">'+msg_text+'</div>');
							dom_text=$(this).closest('.label-check').find('.label-text');
						}
						if(inputs['licencia_enfermeria'].getValor()==1){
							dom_text.hide();
						}else{
							dom_text.show();
						}
					});

					break;
				case 'idioma_programa':
					inputs[data.campos[i]] = new FormularioSelect($(self.main).find('select[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].disableFirst(false);
					$(self.main).find('select[name="'+data.campos[i]+'"]').bind('change', function (){
						var  le_value='';
						if(inputs['idioma_programa'].getValor()=='ESP'){
							le_value='es';
						}else if(inputs['idioma_programa'].getValor()=='ENG'){
							le_value='en';
						}
						inputs['programa_id'].clean();
						var programas = data.programas.filter(function(a){return le_value=='' || a.idioma==le_value});
						var programas_options = programas.map(function(a){ 
							return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};
						});
			
						inputs['programa_id'].set(programas_options);
						//setEscuelasLicenciaRN();
					});

					var select = $(self.main).find('select[name="programa_id"]')[0];
					$(select).bind('change', function(e){
						var value=$(this).val();
						var programa_id=$(this).val();
						var programa = data.programas.filter(function(a){return a.id==programa_id});
						var  le_value=programa[0].idioma;
						if(le_value=='es'){
							$(self.main).find('select[name="idioma_programa"]').val('ESP');
							$(self.main).find('select[name="idioma_programa"]').selectric('refresh');
							$(self.main).find('select[name="idioma_programa"]').trigger('change');
							$(this).val(value);
							$(this).selectric('refresh');
						}else if(le_value=='en'){
							$(self.main).find('select[name="idioma_programa"]').val('ENG');
							$(self.main).find('select[name="idioma_programa"]').selectric('refresh');
							$(self.main).find('select[name="idioma_programa"]').trigger('change');
							$(this).val(value);
							$(this).selectric('refresh');
						}
					});


					break;
				case 'checkbox_terms':
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(true);
					
					var recibe_terms_modal = $('.recibe_terms_modal')[0];
					$(recibe_terms_modal).find('.modal-close').bind('click', function(){
						$(recibe_terms_modal).removeClass('active');
					});
					$('.check_terms_btn').bind('click', function(evt){
						evt.preventDefault();
						$(recibe_terms_modal).addClass('active');
					});
					
					break;
				case 'boton_siguiente':
					break;
				default:
					inputs[data.campos[i]] = new FormularioInput($(self.main).find('input[name="'+data.campos[i]+'"]')[0]);
					inputs[data.campos[i]].esRequerido(false);
					break;

			}
		}

	
		if(inputs['ofrecimiento'] !== undefined){
			onChangeOfrecimiento();
		} else if(inputs['recinto_id'] !== undefined){
			onChangeRecinto();
		}else if(inputs['escuela_id'] !== undefined){
			onChangeEscuela();
		}

		// Verifico si tengo que cargar los programas
		if(inputs['recinto_id'] === undefined && inputs['state'] !== undefined && data.recintos.length > 1 && institute_type === 'NUCO' && landing_usa === true){
			var programas = data.programas.filter(function(programa){ 
				return (data.recintos.filter(function (recinto){
					return recinto.programas.indexOf(programa.id) != -1
				})).length > 0;
			});
			var programas_options = programas.map(function(a){ 
				return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};
			});
			inputs['programa_id'].set(programas_options);
		}
		//-------------------------------------------------------
		
		//Existe track_id porque TplFrtNuco ya chequeó que va a ser necesario que exista
		if($(self.main).find('select[name="track_id"]').length > 0){
			inputs['track_id'] = new FormularioSelect($(self.main).find('select[name="track_id"]')[0]);
			inputs['track_id'].hide();
			$(inputs['programa_id'].getSelect()).bind('change', onChangePrograma);
		}

		/**** DEEP LINK RECINTO ****/
		
		if(preset_recinto_id != '' && inputs['recinto_id'] !== undefined){
			inputs['recinto_id'].seleccionar(preset_recinto_id);		
			onChangeRecinto();	
		}

		/***************************/
		
		
		addHidden();

		trackFBEventLead();

		if(inputs['country'] !== undefined){
			var select = $(self.main).find('select[name="country"]')[0];
			$(select).trigger('change');

			if(inputs['pueblos_paises'] !== undefined){
				inputs['pueblos_paises'].showByQuery('[country_code]');
				inputs['pueblos_paises'].hideByQuery('[country_code!="' + (data.pais && data.pais.codigo ? data.pais.codigo : '') + '"]');
			}

			if(inputs['pueblo_codigo_postal'] !== undefined){
				inputs['pueblo_codigo_postal'].showByQuery('[country_code]');
				inputs['pueblo_codigo_postal'].hideByQuery('[country_code!="' + (data.pais && data.pais.codigo ? data.pais.codigo : '') + '"]');
			}
		}
	}

	function setEscuelasLicenciaRN(){
		//console.log('setEscuelasLicenciaRN');
		if(inputs['programa_id'] !== undefined){
			var  le_value=inputs['licencia_enfermeria'].getValor()==1?'1':'0';
			//inputs['programa_id'].clean();
			//
			//var programa_options = data.programas.filter(function(a){return a.licencia_rn===le_value});
			//inputs['programa_id'].set(programa_options);
			$(self.main).find('select[name="programa_id"]').val(0);
			inputs['programa_id'].find('optgroup').hide();
			inputs['programa_id'].find('option').hide();
			inputs['programa_id'].find('optgroup').attr('disabled','disabled');
			inputs['programa_id'].find('option').attr('disabled','disabled');
			inputs['programa_id'].find('option').each(function(){
				var valueId=$(this).attr('value');
				var program=data.programas.filter(function(a){return a.id==valueId});
				if(program.length>0){
					if(program[0].licencia_rn==le_value){
						$(this).parent().attr('disabled',false);
						$(this).attr('disabled',false);
						$(this).parent().show();
						$(this).show();
					}
				}
			});
			inputs['programa_id'].find('option[disabled=disabled][value!=0]').remove();
			//inputs['programa_id'].find('optgroup[disabled=disabled]').remove();
			$(self.main).find('select[name="programa_id"]').selectric('refresh');
		}

	}

	function formConfigValido(){
		if(data.campos.indexOf('country') !== -1 && data.campos.indexOf('recinto_id') === -1){
			alert('Existe pais pero no hay un dropdown de recintos en el formulario');
			return false;
		}
		if(data.campos.indexOf('programa_id') == -1 && data.programas.length > 1){
			alert('Existe más de un programa pero no hay un dropdown de programas en el formulario');
			return false;
		}
		if((institute_type !== 'NUCO' || landing_usa !== true || data.campos.indexOf('state') == -1) &&  data.campos.indexOf('recinto_id') == -1 && data.recintos.length > 1){
			alert('Existe más de un recinto pero no hay un dropdown de recintos en el formulario');
			return false;
		}
		if(data.campos.indexOf('pueblo_codigo_postal') !== -1 && $(self.main).find('select[name="pueblo_codigo_postal"]').length==0){
			alert('No esta definido el pueblo_codigo_postal');
			return false;
		}
		if(data.campos.indexOf('idioma_programa') !== -1 && data.programas.length < 2){
			alert('Para filtrar por idioma debe de tener al menos dos programas definidos');
			return false;
		}

		return true;
	}
	
	function addHidden(){
		if(data.programas.length == 1 && data.campos.indexOf('programa_id') == -1){
			$(self.main).append('<input type="hidden" name="programa_id" value="'+data.programas[0].id+'"/>');
		}
		if(data.recintos.length == 1 && data.campos.indexOf('recinto_id') == -1){
			$(self.main).append('<input type="hidden" name="recinto_id" value="'+data.recintos[0].id+'"/>');
		}
		if(institute_type === 'NUCO' && landing_usa === true && data.recintos.length > 1 && data.campos.indexOf('recinto_id') == -1 && data.campos.indexOf('state') != -1){
			$(self.main).append('<input type="hidden" id="recinto_id" name="recinto_id"/>');
		}
		$(self.main).append('<input type="hidden" name="landing_id" value="'+landing_id+'"/>');
		$(self.main).append('<input type="hidden" name="lead_source" value="'+lead_source+'"/>');
		$(self.main).append('<input type="hidden" name="utm_source" value="'+utm_source+'"/>');
		$(self.main).append('<input type="hidden" name="utm_medium" value="'+utm_medium+'"/>');
		$(self.main).append('<input type="hidden" name="utm_term" value="'+utm_term+'"/>');
		$(self.main).append('<input type="hidden" name="utm_content" value="'+utm_content+'"/>');
		$(self.main).append('<input type="hidden" name="utm_campaign" value="'+utm_campaign+'"/>');
		$(self.main).append('<input type="hidden" name="utm_keyword" value="'+utm_keyword+'"/>');
		$(self.main).append('<input type="hidden" name="utm_image" value="'+utm_image+'"/>');
		$(self.main).append('<input type="hidden" name="utm_ad_id" value="' + utm_ad_id + '"/>');
		$(self.main).append('<input type="hidden" name="utm_adset_id" value="' + utm_adset_id + '"/>');
		$(self.main).append('<input type="hidden" name="utm_campaign_id" value="' + utm_campaign_id + '"/>');
		$(self.main).append('<input type="hidden" name="utm_feed_extension_id" value="' + utm_feed_extension_id + '"/>');
		$(self.main).append('<input type="hidden" name="utm_extension_id" value="' + utm_extension_id + '"/>');
		$(self.main).append('<input type="hidden" name="utm_placement" value="' + utm_placement + '"/>');
		$(self.main).append('<input type="hidden" name="utm_device" value="' + utm_device + '"/>');
		$(self.main).append('<input type="hidden" name="utm_network" value="' + utm_network + '"/>');
	}

	function onChangeOfrecimiento(e){
		if(inputs['ofrecimiento'].getValor() == 0){
			if(inputs['recinto_id'] !== undefined){
				inputs['recinto_id'].clean();
			}
		}else if(inputs['recinto_id'] !== undefined){
			var ofrecimiento_id = inputs['ofrecimiento'].getValor();
			var recintos = data.recintos.filter(function(a){return a.ofrecimiento===ofrecimiento_id});
			var recintos_options = recintos.map(function(a){
				return {
					valor:a.id, 
					nombre: data.pais.latam && parseInt(data.pais.latam) === 1 
						? a.nombre_latam 
						: a.nombre,
					selected:false
				}
			});
			inputs['recinto_id'].set(recintos_options);
			if(inputs['programa_id'] !== undefined){ //No hay escuelas pero si programas
				var	programas = data.programas.filter(function(programa){ 
					return (recintos.filter(function (recinto){
						return recinto.programas.indexOf(programa.id) != -1
					})).length > 0;
				}); 
				var programas_options = programas.map(function(a){ return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};});
				var programa_id=inputs['programa_id'].getValor();
				inputs['programa_id'].set(programas_options);
				if(programa_id>0){
					inputs['programa_id'].seleccionar(programa_id);
				}
			}
		}
		if(inputs['track_id'] !== undefined){
			inputs['track_id'].clean();
			inputs['track_id'].hide();
		}
	}

	function onChangeRecinto(e){
		//console.log('onChangeRecinto');
		if(inputs['recinto_id'] === undefined){
			var recinto_id = $(self.main).find('input[name="recinto_id"]')[0].value;
		} else {
			var recinto_id = inputs['recinto_id'].getValor();
		}
		if(recinto_id == 0){
			if(inputs['escuela_id'] !== undefined){
				inputs['escuela_id'].clean();
			}

			if(inputs['programa_id'] !== undefined){
				//inputs['programa_id'].clean();
			}
		}else{
			var recinto = data.recintos.filter(function(a){return a.id == recinto_id})[0];
			if(inputs['escuela_id'] !== undefined){ //Hay escuelas
				var escuelas_ids = data.programas.filter(function(a){return recinto.programas.indexOf(a.id) != -1}).map(function(a){return a.escuela_id}).filter(function(valor, index, arr){ return index == arr.indexOf(valor);});
				var escuelas = data.escuelas.filter(function(a){return escuelas_ids.indexOf(a.id) != -1});
				var escuelas_options = escuelas.map(function(a){return {valor:a.id, nombre: a.nombre}});
				inputs['escuela_id'].set(escuelas_options);
				if (escuelas_options.length === 1){
					inputs['escuela_id'].seleccionar(escuelas_options[0].valor);
					$(inputs['escuela_id'].getSelect()).attr('selected_option', escuelas_options[0].valor);
				}					
				onChangeEscuela();
				/*if(inputs['programa_id'] !== undefined){
					//inputs['programa_id'].clean();
					$(inputs['programa_id'].getSelect()).attr('skip_filter', 1);		
				}*/
			}
			if(inputs['programa_id'] !== undefined){ //No hay escuelas pero si programas
				var	programas = data.programas.filter(function(a){ return recinto.programas.indexOf(a.id) != -1}); 
				var programas_options = programas.map(function(a){ return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo, params: a.params};});
				if(!$(inputs['recinto_id'].getSelect()).attr('skip_filter')){
					if(landing_usa){
						programas = mapConcentrationTracks(programas);
					}
					var programa_id=inputs['programa_id'].getValor();
					inputs['programa_id'].set(programas_options);
					if(programa_id>0){
						inputs['programa_id'].seleccionar(programa_id);
					}
					$(inputs['programa_id'].getSelect()).attr('skip_filter', 1);
				}
				if (programas_options.length === 1){
					inputs['programa_id'].seleccionar(programas_options[0].valor);
					$(inputs['programa_id'].getSelect()).attr('selected_option', programas_options[0].valor);
				}
				// tipo puede ser undefined (ese caso está contemplado en FormularioSelect)
			}
		}
		if(inputs['licencia_enfermeria'] !== undefined && inputs['licencia_enfermeria'].getValor()!=''){
			$(self.main).find('select[name="recinto_id"] option').hide();
			$(self.main).find('select[name="recinto_id"] option').attr('disabled','disabled');
			le_value=inputs['licencia_enfermeria'].getValor()==1?'1':'0';
			recinto_value='';
			for( var i in data.programas){
				if(data.programas[i].licencia_rn==le_value){
					for( var j in data.recintos){
						if(data.recintos[j].programas.indexOf(data.programas[i].id)!=-1){
							if(inputs['recinto_id'].getValor()==data.recintos[j].id){
								recinto_value=data.recintos[j].id;
							}
							$(self.main).find('select[name="recinto_id"] option[value='+data.recintos[j].id+']').show();
							$(self.main).find('select[name="recinto_id"] option[value='+data.recintos[j].id+']').attr('disabled', false);
						}
					}
				}
			}
			//$(self.main).find('select[name="recinto_id"] option[disabled=disabled]:not(:first-child)').remove();
			$(self.main).find('select[name="recinto_id"]').val(recinto_value);
			$(self.main).find('select[name="recinto_id"]').selectric('refresh');

			setEscuelasLicenciaRN();
		}

		if(inputs['track_id'] !== undefined){
			inputs['track_id'].clean();
			inputs['track_id'].hide();
		}	
	}

	function onChangeEscuela(e){
		//console.log('onChangeEscuela');
		if(inputs['escuela_id'].getValor() == 0){
			if(inputs['programa_id'] !== undefined){
				inputs['programa_id'].clean();
			}
		}else if(inputs['programa_id'] !== undefined){
			var id_escuela = inputs['escuela_id'].getValor();
			if(inputs['recinto_id'] !== undefined){
				var recinto = data.recintos.filter(function(a){return a.id == inputs['recinto_id'].getValor()})[0];
				var programas_options = data.programas.filter(function(a){return a.escuela_id == id_escuela && recinto.programas.indexOf(a.id) != -1 }).map(function(a){ return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo}});
				
			}else{
				var programas_options = data.programas.filter(function(a){return a.escuela_id == id_escuela}).map(function(a){ return {valor:a.id, escuela_id:a.escuela_id, nombre: data.pais.latam && parseInt(data.pais.latam) === 1 ? a.nombre_latam : a.nombre, tipo: a.tipo}});
			}
			if((inputs['recinto_id'] !== undefined && !$(inputs['recinto_id'].getSelect()).attr('skip_filter')) || inputs['recinto_id'] === undefined){
				inputs['programa_id'].set(programas_options);
			}
			if (programas_options.length === 1){
				inputs['programa_id'].seleccionar(programas_options[0].valor);
				$(inputs['programa_id'].getSelect()).attr('selected_option', programas_options[0].valor);
			}
		}

		if(inputs['licencia_enfermeria'] !== undefined && inputs['licencia_enfermeria'].getValor()!=''){
			$(self.main).find('select[name="escuela_id"] option').hide();
			$(self.main).find('select[name="escuela_id"] option').attr('disabled','disabled');
			le_value=inputs['licencia_enfermeria'].getValor()==1?'1':'0';
			escuela_value='';
			for( var i in data.programas){
				if(data.programas[i].licencia_rn==le_value){
					if(inputs['escuela_id'].getValor()==data.programas[i].escuela_id){
						escuela_value=data.programas[i].escuela_id;
					}
					$(self.main).find('select[name="escuela_id"] option[value='+data.programas[i].escuela_id+']').show();
					$(self.main).find('select[name="escuela_id"] option[value='+data.programas[i].escuela_id+']').attr('disabled', false);
				}
			}
			//$(self.main).find('select[name="escuela_id"] option[disabled=disabled]:not(:first-child)').remove();
			$(self.main).find('select[name="escuela_id"]').val(escuela_value);
			$(self.main).find('select[name="escuela_id"]').selectric('refresh');

			setEscuelasLicenciaRN();
		}

		if(inputs['track_id'] !== undefined){
			inputs['track_id'].clean();
			inputs['track_id'].hide();
		}
	}

	function onChangePrograma(e){
		//console.log('onChangePrograma');
		if (inputs['programa_id'] === undefined){
			return;
		}
		var option = inputs['programa_id'].getSelectedOption();
		var esGrupo = $(option).data('grupo_id') || false;
		var programa = data.programas.find(function (programa){
			return programa.id == $(option).val();
		});
		if(inputs['recinto_id'] !== undefined){
			var recintos_options = data.recintos.filter(function(recinto){return recinto.programas.filter(function(programa_id){return programa && programa.id===programa_id}).length>0}).map(function(recinto){return{valor:recinto.id,nombre:recinto.nombre,selected:false}});
			if(!$(inputs['programa_id'].getSelect()).attr('skip_filter')){
				inputs['recinto_id'].set(recintos_options);
				$(inputs['recinto_id'].getSelect()).attr('skip_filter', 1);
			}
			if (recintos_options.length === 1){
				inputs['recinto_id'].seleccionar(recintos_options[0].valor);
				$(inputs['recinto_id'].getSelect()).attr('selected_option', recintos_options[0].valor);
				onChangeRecinto();
			}
		}
		// Solo en el caso de NUCO y landing usa
		if(institute_type === 'NUCO' && landing_usa === true){
			if(programa && inputs['state'] !== undefined){
				opstate = inputs['state'].getSelectedOption();
				if($(opstate).val() != 0){
					var estado = data.states.find(function(state){
						return $(opstate).val() === state.codigo;
					});
					// En este punto verifico a que recinto va a enviar
					var recintos = data.recintos.filter(function(recinto){
						return recinto.programas.filter(function(programa_id){
							return programa && programa.id===programa_id
						}).length>0});
					// En el caso que exista más de un recinto verifico cual se envia
					if(recintos.length > 1){
						recintos = recintos.filter(function(recinto){
							if (estado.us == 1 && recinto.latam == 1){
								return true;
							}
							if (estado.us == 0 && recinto.latam == 0){
								return true;
							}
							return false;
						});
					}
					$('#recinto_id').val(recintos[0].id);
				}
			}
		}
		if(inputs['track_id'] === undefined){
			return;
		}
		if(esGrupo){
			var programas = data.programas.filter(function(programa){
				return programa.grupo_id == $(option).data('grupo_id') && programa.tipo == $(option).data('tipo');
			})
			inputs['track_id'].set(programas.map(function(a){ return {valor:a.id, nombre: a.nombre_ct, tipo: a.tipo};}))
			inputs['track_id'].show();
		}else{
			inputs['track_id'].clean();
			inputs['track_id'].hide();
		}
	}

	function mapConcentrationTracks(programas){
		var result = [];
		programas.forEach(function(programa, index){
			if(programa.grupo_id != 0){
				var grupo_data = data.grupos_programas.filter(function(item){ return item.id == programa.grupo_id;})[0];
				var new_item = {};
				new_item.id = 0;
				new_item.nombre = grupo_data.nombre;
				new_item.tipo = programa.tipo;
				new_item.params = {grupo_id: grupo_data.id, tipo: programa.tipo};
				if(result.filter(function(item){
					return item.id == 0 && item.params.grupo_id == new_item.params.grupo_id && item.tipo == new_item.tipo;}).length == 0){
					result.push(new_item);
				}
			}else{
				result.push(programa);
			}
		});
		return result;					
	}

	function isGeneric(){
		return data.escuelas.length > 1 ?  true : false;
	}

	function getProgram(){
		var programa_id = (data.programas.length == 1) ? data.programas[0].id : inputs['programa_id'].getValor();
		if (programa_id == 0){
			return false;
		}
		var program = data.programas.find(function(p){return p.id == programa_id});
		program.slug = stringToFBSlug (program.nombre);
		return program;
	}

	function getPrograms(){
		return data.programas.map(function(p){
			return p.program_id
		})
	}
	
	function getRecinto(){
		if(data.recintos.length == 1){
			var recinto_id = data.recintos[0].id;	
		}else if(typeof inputs['recinto_id']!='undefined'){
			var recinto_id=inputs['recinto_id'].getValor();
		}else{
			return false;
		}
		//var recinto_id = (data.recintos.length == 1) ? data.recintos[0].id : inputs['recinto_id'].getValor();
		//if (recinto_id == 0){	
		//	return false;
		//}
		var recinto = data.recintos.find(function(p){return p.id == recinto_id});
		if(typeof recinto!='undefined' && typeof recinto.nombre!='undefined'){
			recinto.slug = stringToFBSlug (recinto.nombre);
			return recinto;
		}else{
			return false;
		}
	}
	
	function getCategory(program){
		var category_type = {'GA': 'Grado Asociado', 'BA': 'Bachillerato', 'MA': 'Maestría'};
		if (program.tipo && category_type[program.tipo]){
			return {
				slug:stringToFBSlug (category_type[program.tipo])
			};
		}
		return false;
	}
	
	function getSchool(program){
		if (!data.escuelas){
			return false;
		}
		var school = data.escuelas.find(function(p){return p.id == program.escuela_id});
		if (school){
			school.slug = stringToFBSlug (school.nombre);
			return school;
		}
		return false;
	}
	
	function getFbPixelData(){
		var pixel = {};
		var program = getProgram();
		if (program !== false){
			pixel.program = program;
		} else {
			pixel.programs = getPrograms();
		}
		var recinto = getRecinto();
		if (recinto !== false){
			pixel.recinto = recinto;
		}
		var category = getCategory(program);
		if (category !== false){
			pixel.category = category;
		}
		var school = getSchool(program);
		if (school !== false){
			pixel.school = school;
		}
		if(data.pais){
			pixel.country = data.pais;
		}
		if(inputs['pueblos_paises'] !== undefined && inputs['pueblos_paises'].getValor() != 0){
			pixel.state = {slug:inputs['pueblos_paises'].getTexto()};
		}
		if(inputs['state'] !== undefined && inputs['state'].getValor() != 0){
			pixel.state = {slug:inputs['state'].getTexto()};
		}
		return pixel
	}
	
	function trackFBEventCompleteRegistration(){
		if(typeof getFbPixelData=='undefined'){
			return false;
		}
		var pixeldata = getFbPixelData();
		(new Pixel())
			.set('content_type', 'product')
			.set('content_name', pixeldata.program ? pixeldata.program.slug : false)
			.set('content_id', pixeldata.program ? pixeldata.program.program_id : false )
			.set('content_country', pixeldata.country ? pixeldata.country.nombre : false )
			.set('content_state', pixeldata.state ? pixeldata.state.slug : false )
			.set('content_campus', pixeldata.recinto ? pixeldata.recinto.slug : false )
			.set('content_school', pixeldata.school ? pixeldata.school.slug : false )
			.set('external_id', $('input[name="fb_event_id"]').val())
			.set('user_data', {
				client_user_agent: $('#fb_client_user_agent').val()
			})
			.set('event_source_url', $('#fb_event_source_url').val())
			.set('action_source', $('#fb_action_source').val())
			.set('currency', 'USD')
			.set('value', '1')
			.send('Purchase');
	}
	
	function trackFBEventLead(){
		if(typeof getFbPixelData=='undefined'){
			return false;
		}
		var pixeldata = getFbPixelData();
		(new Pixel())
			.set('content_type', 'product')
			.set('content_name', pixeldata.program ? pixeldata.program.slug : false)
			.set('content_id', pixeldata.program ? pixeldata.program.program_id : false )
			.set('content_ids', pixeldata.programs ? pixeldata.programs : false )
			.set('content_country', pixeldata.country ? pixeldata.country.nombre : false )
			.set('content_state', pixeldata.state ? pixeldata.state.slug : false )
			.set('content_campus', pixeldata.recinto ? pixeldata.recinto.slug : false )
			.set('content_school', pixeldata.school ? pixeldata.school.slug : false )
			.set('user_data', {
				client_user_agent: $('#fb_client_user_agent').val()
			})
			.set('event_source_url', $('#fb_event_source_url').val())
			.set('action_source', $('#fb_action_source').val())
			.set('currency', 'USD')
			.set('value', '1')
			.send('ViewContent');
		//fbq('trackCustom', 'ViewContent', pixel);
	}

	function onClickEnviarBtn(e){
		var main = document.getElementById('formulario');

		e.preventDefault();

		// Verifico que país esta seleccionado antes de hacer la validacion
		if (inputs.hasOwnProperty('country')){
			inputs['telefono'].setPais({
				nregexp:inputs['country'].getSelectedOption().getAttribute('nregexp')
			});
		}

		if(!enviando){
			var todo_bien = true;

			myActualPage=0;
			validateCheckRecibeInfo=false;

			var campoError='campos';
			for( var key in inputs){
				var tInput=$(inputs[key].getInput());
				if(tInput.hasClass('selectric')){
					tInput=tInput.closest('.mobile-select');
				}
				
				if(myActualPage==actualPage && inputs[key].isActive()){
					if(!inputs[key].esCorrecto()){
						if(todo_bien && key=='birthdate'){
							campoError='birthdate';
						}
						todo_bien = false;
						inputs[key].setError(true);
					}else{
						inputs[key].setError(false);
					}
				}
				if(tInput.next().length>0 && tInput.next().hasClass('button_next')){
					myActualPage++;
				}
			}

			if($(main).find('input[name=recibe_info]').length>0 && $(main).find('input[name=recibe_info]').is(':visible')){
				validateCheckRecibeInfo=true;
			}
			if(validateCheckRecibeInfo && check_recibe_info != null){
				if(!check_recibe_info.checked){
					todo_bien = false;
					$(check_recibe_info).addClass('error');
				}else{
					$(check_recibe_info).removeClass('error');
				}
			}

			if(todo_bien){
				if(typeof inputs['birthdate'] !== 'undefined' ){
					var tArr=inputs['birthdate'].getValor().split('/');
					
					if(tArr.length!=3){
						inputs['birthdate'].setError(true);
						mostrarError('birthdate');
						return false;
					}
					var date=tArr[2]+'-'+tArr[1]+'-'+tArr[0];
					var yourDate = new Date()
					var dateEnd=yourDate.toISOString().split('T')[0];
					
					yourDate.setFullYear(yourDate.getFullYear() - 100);
					var dateInit=yourDate.toISOString().split('T')[0];
					
					if(date<dateInit || date>dateEnd){
						inputs['birthdate'].setError(true);
						mostrarError('birthdate');
						return false;
					}
				}
				
				//TODO: Si el telefono no esta en la primer pagina este esta mal
				//Va a dar error siempre
				if(typeof inputs['telefono'] !== 'undefined' && !inputs['telefono'].esTelefonoValido() && !warningTelefono){
					!inputs['telefono'].setError(true);
					// Verifico que solo pase en el segundo intento si no tiene pais seleccionado
					// ni por defecto de la landing ni por campo select
					warningTelefono = data.pais || inputs.hasOwnProperty('country') ? false : true;
					mostrarError('telefono');
					return false;
				}
				if ($(e.currentTarget).hasClass('button_next')){
					actualPage++;
					showPage(actualPage);
				}else{
					grecaptcha.execute();
				}
			}else{
				mostrarError(campoError);
			}
		}
		
	}

	function showPage(page){
		myActualPage=0;
		if(page==0){
			$('#formulario_enviar_btn').prev().hide();
		}else{
			$('#formulario').prev().hide();
		}
		$('#formulario').children().each(function(){
			if(page==myActualPage){
				$(this).show();
			}else{
				$(this).hide();
			}
			if($(this).hasClass('button_next')){
				myActualPage++;
			}
		});
		$("html, body").animate({scrollTop:0}, 500);
		$('#formulario_msg').show();
	}

	function onRecaptcha(){
		if(inputs['nombre'].esCorrecto()){//Hack para prevenir execute previo recaptcha (issue)
			enviando = true; 
			$(enviar_btn).addClass('loading');	
			
			$.ajax({
				url:WEB_PATH+'ajax/',
				type: 'post',
				data: $(self.main).serialize(),
				success:onGuardoParticipacion
			})

			grecaptcha.reset();
			warningTelefono = false;
		}
	}

	function onGuardoParticipacion(response){
		enviando = false;
		$(enviar_btn).removeClass('loading');

		if(response.error){
			mostrarError(typeof response.msg!='undefined'?response.msg:'duplicado');
		}else{
			trackFBEventCompleteRegistration();
			
			// Uso el setTimeout para que de el tiempo a que se envie el track de Facebook.
			// (esto porque al momento la Tag API de Facebook no tiene hitCallback)
			setTimeout(function(){
				window.location.href = window.location.protocol+'//'+ window.location.host + window.location.pathname + 'complete';
			},1200);
		}

		resetear();
	}

	function resetear(){
		for( var key in inputs){
			inputs[key].resetear();
		}

		if(inputs['recinto_id'] !== undefined){
			onChangeRecinto();
		}else if(inputs['escuela_id'] !== undefined){
			onChangeEscuela();
		}
	}

	function mostrarError(error){
		switch(error){
			case 'campos': 
				$(formulario_msg).html('<p>'+$(formulario_msg).data('error-campos')+'</p>');
				break;
			case 'telefono': 
				$(formulario_msg).html('<p>'+$(formulario_msg).data('error-telefono')+'</p>');
				break;			   
			case 'birthdate': 
				$(formulario_msg).html('<p>'+$(formulario_msg).data('error-birthdate')+'</p>');
				break;			   
			case 'duplicado': 
				$(formulario_msg).html('<p>'+$(formulario_msg).data('error-duplicado')+'</p>');
				break;
			default:
				$(formulario_msg).html('<p>'+error+'</p>');					
			break;
		}
		$(formulario_msg).addClass('active');

		setTimeout(function(){
			$(formulario_msg).removeClass('active');	
		},5000)
	}

	function stringToFBSlug (str) {
		str = str.replace(/^\s+|\s+$/g, ''); // trim
		str = str.toLowerCase();
	  
		// remove accents, swap ñ for n, etc
		var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
		var to   = "aaaaeeeeiiiioooouuuunc------";
		for (var i=0, l=from.length ; i<l ; i++) {
			str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
		}

		str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
			.replace(/\s+/g, '-') // collapse whitespace and replace by -
			.replace(/-+/g, '-'); // collapse dashes

		return str;
	}

}

w.Formulario = Formulario;
})(window)
